/**
 * @param {object} obj
 */
function postMessage (obj) {
  if (typeof window === 'undefined' || !window.parent || !obj) return
  window.parent.postMessage(obj, '*')
}

module.exports = { postMessage }
